import { useSearchParams } from 'react-router-dom';
import { ReportingContainerBaseConfig } from '../../../base';
import {
    SourceListController,
    SourceListLoader,
    SourceListStateProvider,
} from './sourceListInterface';
import { SourceListContainerProps } from './sourceListProps';

export function createSourceListContainer(
    config: ReportingContainerBaseConfig,
    states: SourceListStateProvider,
    loader: SourceListLoader,
    controller: SourceListController
): React.FC<SourceListContainerProps> {
    const {
        kernel: {},
        context: { useContext },
    } = config;
    return ({ as: Component, ...containerProps }) => {
        const [searchParams, setSearchParams] = useSearchParams();
        const context = useContext();
        const data = loader.useLoad(context, containerProps);
        const state = states.useState(context, data);
        const props = controller.useProps(context, data, {
            active: state.active,
            expanded: state.expanded,
            onOpen(source) {
                searchParams.set('source', source.id);
                setSearchParams(searchParams, { replace: true });
            },
        });
        return <Component {...props} />;
    };
}
